getEventComplete